import Currency from "./Currency.ts";

export default class CryptoCurrency extends Currency {
}
